<template>
    <div>
        <form @submit.prevent class="m-form" name="claimantForm">
            <div class="flex-grid flex-grid--reduced-bottom-margin a-form-inputs">
                <div class="flex-grid__item">
                    <control for="claimantName" label="Claimant Name" v-if="showNames">
                        <input autocomplete="off" v-model="name"
                               required
                               name="claimantName"
                               id="claimantName"
                               v-field-control:claimantName.required="{type:'text', rules:'name'}"
                               maxlength="100"
                               type="text">
                        <control-error :show="$error('claimantName')">
                            The claimant name is required and must be a valid name
                        </control-error>
                    </control>

                    <typeahead
                            :required=true
                            :label="'Claimant Solicitors'"
                            :error-message="'The claimant solicitor is required and must be a valid name'"
                            :value="claimantSolicitor"
                            :type="'claimant_solicitors'"
                            @update="updateClaimantSolicitors"
                    ></typeahead>

                    <control for="claimaint_reference" label="Claimant Reference">
                        <input autocomplete="off" v-model="claimantReference"
                               v-field-control
                               required
                               class="input"
                               maxlength="100"
                               name="claimaint_reference" type="text">
                        <control-error :show="$error('claimaint_reference')">
                            The claimant reference is required
                        </control-error>
                    </control>
                    <control for="claimant_gender" label="Claimant Gender">
                        <select v-field-control
                                v-model="gender"
                                required
                                name="claimant_gender">
                            <option :value="null" disabled hidden>Please select...</option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                        </select>
                        <control-error :show="$error('claimant_gender')">
                            The claimant's gender is required
                        </control-error>
                    </control>
                    <control for="claimant_date_of_birth" label="Claimant Date of Birth">
                        <date-input-d-o-b v-model="dateOfBirth"
                                          v-field-control:claimant_date_of_birth.required="{type:'date'}"
                        ></date-input-d-o-b>
                        <control-error :show="$error('claimant_date_of_birth')">
                            The claimant's date of birth is required and must be in the format DD/MM/YYYY
                        </control-error>
                    </control>

                    <control name="disease_or_accident" label="Disease or Accident?">
                        <select name="disease_or_accident"
                                id="disease_or_accident"
                                v-field-control
                                v-model="diseaseOrAccident"
                                required>
                            <option :value="null" disabled hidden>Please select...</option>
                            <option value="disease">Disease</option>
                            <option value="accident">Accident</option>
                        </select>
                        <control-error :show="$error('disease_or_accident')">
                            The disease type is required
                        </control-error>
                    </control>

                    <div v-if="diseaseOrAccident === 'disease'">
                        <control name="disease_type" label="Disease">
                            <select name="disease_type"
                                    id="disease_type"
                                    v-field-control
                                    v-model="diseaseType"
                                    required>
                                <option :value="null" disabled hidden>Please select...</option>
                                <option value="Asbestos Related Lung Cancer">Asbestos Related Lung Cancer</option>
                                <option value="Bladder Cancer">Bladder Cancer</option>
                                <option value="Kidney Cancer">Kidney Cancer</option>
                                <option value="Laryngeal Cancer">Laryngeal Cancer</option>
                                <option value="Leukemia">Leukemia</option>
                                <option value="Liver Cancer">Liver Cancer</option>
                                <option value="Mesothelioma">Mesothelioma</option>
                                <option value="Nasal Cancer">Nasal Cancer</option>
                                <option value="Skin Cancer">Skin Cancer</option>
                                <option disabled> - - -</option>
                                <option value="Other Cancer">Other Cancer &mdash; Specify Type</option>
                                <option disabled> - - -</option>
                                <option value="Other">Other &mdash; Specify Type</option>
                            </select>
                            <control-error :show="$error('disease_type')">
                                The disease type is required
                            </control-error>
                        </control>
                        <control name="disease_type_other" label="Disease Type Other"
                                 v-if="diseaseType && diseaseType.substr(0, 5) === 'Other'">
                            <input autocomplete="off" type="text"
                                   name="disease_type_other"
                                   id="disease_type_other"
                                   v-field-control
                                   required
                                   v-model="otherDiseaseType">
                            <control-error
                                    :show="$error('disease_type_other') || otherDiseaseType === null || otherDiseaseType === undefined">
                                The disease type is required
                            </control-error>
                        </control>
                    </div>

                    <div v-if="diseaseOrAccident === 'accident'">
                        <control name="accident_type" label="Accident">
                            <select name="accident_type"
                                    id="accident_type"
                                    v-field-control
                                    v-model="accidentType"
                                    required>
                                <option :value="null" disabled hidden>Please select...</option>
                                <option value="Accident - EL">Accident - EL</option>
                                <option value="Accident - PL">Accident - PL</option>
                                <option value="Motor">Motor</option>
                                <option value="Other">Other &mdash; Specify Type</option>
                            </select>
                            <control-error :show="$error('accident_type')">
                                The accident type is required
                            </control-error>
                        </control>
                        <control name="other_accident_type" label="Accident Type Other"
                                 v-if="accidentType && accidentType.substr(0, 5) === 'Other'">
                            <input autocomplete="off" type="text"
                                   name="other_accident_type"
                                   id="other_accident_type"
                                   v-field-control
                                   required
                                   v-model="accidentTypeOther">
                            <control-error
                                    :show="$error('accident_type_other') || accidentTypeOther === null || accidentTypeOther === undefined">
                                The accident type is required
                            </control-error>
                        </control>
                    </div>
                </div>
                <div class="flex-grid__item flex-grid--space-left">
                    <control for="your_reference" label="Your Reference">
                        <input autocomplete="off" v-model="yourReference"
                               v-field-control
                               required
                               name="your_reference"
                               maxlength="30"
                               type="text">
                        <control-error :show="$error('your_reference')">
                            Your reference is required
                        </control-error>
                    </control>
                    <control for="pre_lit_or_lit" label="Procedural Status">
                        <select name="pre_lit_or_lit" id="pre_lit_or_lit" v-model="preLitOrLit" v-field-control
                                required>
                            <option value="pre-lit">Pre-Litigation</option>
                            <option value="litigated">Litigated</option>
                        </select>
                        <control-error :show="$error('pre_lit_or_lit')">
                            Procedural status is required
                        </control-error>
                    </control>

                    <typeahead
                            :required=true
                            :label="'Defendant Name'"
                            :error-message="'The defendant name is required and must be a valid name'"
                            :value="defendantName"
                            :type="'defendant'"
                            @update="updateDefendant"
                    ></typeahead>

                    <control for="service_of_proceedings"
                             label="Date of Service of Proceedings"
                             v-if="preLitOrLit == 'litigated'">
                        <date-input v-model="dateOfServiceProceedings"
                                    v-field-control:date_of_service_proceedings.required="{type:'date'}"
                        ></date-input>
                        <control-error
                                :show="$error('date_of_service_proceedings') || (!serviceProceedingsDateRules() && dateOfAssumedSettlement !== null)">
                            Date of service of proceedings is required, must be in the format DD/MM/YYYY, must be
                            on or before date of assumed settlement/trial <span v-if="dateOfAssumedSettlement">({{ dateOfAssumedSettlement }})</span>
                        </control-error>
                    </control>
                    <control for="date_of_assumed_settlement" label="Date of Assumed Settlement/Trial">
                        <date-input v-model="dateOfAssumedSettlement"
                                    v-field-control:date_of_assumed_settlement.required="{type:'date'}"
                        ></date-input>
                        <control-error
                                :show="$error('date_of_assumed_settlement') || (!assumedSettlementDateRules() && dateOfAssumedSettlement !== null)">
                            Date of assumed settlement/trial is required, must be in the format DD/MM/YYYY,
                            must be after the date of service of proceedings
                            and after no more than 9 years after the date of issue of proceedings
                        </control-error>
                        <control-warning :show="dateOfAssumedSettlementInPast">
                            <warning-box modal-name="warning">
                                <svg slot="icon" viewBox="0 0 120 120" class="m-icon m-icon--dark m-icon--small open">
                                    <use xlink:href="#warning"></use>
                                </svg>
                                <span class="c-warning-box__orange">Date of assumed settlement is in the past</span>
                            </warning-box>
                        </control-warning>
                    </control>
                    <control for="discount_rate" label="Discount Rate">
                        <select name="discount_rate" id="discount_rate" v-model="discountRate" v-field-control
                                required>
                            <option :value="-2.0">-2.00%</option>
                            <option :value="-1.5">-1.50%</option>
                            <option :value="-1.0">-1.00%</option>
                            <option :value="-0.75">-0.75%</option>
                            <option :value="-0.5">-0.50%</option>
                            <option :value="-0.25">-0.25%</option>
                            <option :value="0.0">0.00%</option>
                            <option :value="0.5">0.50%</option>
                            <option :value="1.0">1.00%</option>
                            <option :value="1.5">1.50%</option>
                            <option :value="2.0">2.00%</option>
                            <option :value="2.5">2.50%</option>
                            <option :value="3.0">3.00%</option>
                        </select>
                        <control-error :show="$error('discount_rate')">
                            Discount rate is required
                        </control-error>
                    </control>
                </div>
            </div>
            <div class="a-form-inputs flex-grid__item--full">
                <control for="claim_narrative" label="Claim Narrative"
                         tip-text="Provide a brief background to the claim and issues in dispute. This narrative will populate your counter-schedule of loss."
                         tip-icon="info"
                         tip-side="left"
                         tip-width="250"
                         tip-name="claim_narrative">
                    <textarea required
                              rows="4"
                              v-field-control:claim_narrative.required="{type:'text'}"
                              v-model="claimNarrative"
                              name="claim_narrative"
                              class="u-full-width"></textarea>
                    <control-error :show="$error('claim_narrative')">
                        The claim narrative is required
                    </control-error>
                </control>
            </div>
        </form>
        <step-button :prev-valid="false" :next-valid="isValid"></step-button>
    </div>
</template>

<script type="text/babel">
    import {mapActions, mapGetters} from 'vuex';
    import StepButton from 'components/StepButton.vue';
    import Control from 'components/form/Control.vue';
    import ControlError from 'components/form/control/Error.vue';
    import ControlWarning from 'components/form/control/Warning.vue';
    import FormValidator from 'components/form/validator/mixin';
    import {setStepValid} from 'services/routingMethods';
    import DateInputDOB from 'components/form/control/LostYearsDOBDateInput.vue';
    import DateInput from 'components/form/control/DateInput.vue';
    import moment from 'moment';
    import {validDate} from 'components/form/validator/validations';
    import WarningBox from 'components/modal/WarningBox.vue';
    import Typeahead from "components/Typeahead";

    export default {
        name: 'claimant-details',
        computed: {
            ...mapGetters('lost/claimant', [
                'claimant',
                'getClaimantValue',
                'getClaimantDetail',
                'getClaimantInfoValue'
            ]),
            ...mapGetters('user', ['showNames']),
            name: {
                get() {
                    return this.getClaimantValue('name');
                },
                set(value) {
                    this.updateClaimantValue({key: 'name', value});
                }
            },
            claimantSolicitor: {
                get() {
                    return this.getClaimantDetail('claimantSolicitor');
                }
            },
            claimantReference: {
                get() {
                    return this.getClaimantDetail('claimantReference');
                },
                set(value) {
                    this.updateClaimantDetail({key: 'claimantReference', value});
                }
            },
            yourReference: {
                get() {
                    return this.getClaimantDetail('yourReference');
                },
                set(value) {
                    this.updateClaimantDetail({key: 'yourReference', value});
                }
            },
            gender: {
                get() {
                    return this.getClaimantValue('gender');
                },
                set(value) {
                    this.updateClaimantValue({key: 'gender', value});
                }
            },
            dateOfBirth: {
                get() {
                    return this.getClaimantValue('dateOfBirth');
                },
                set(value) {
                    this.updateClaimantValue({key: 'dateOfBirth', value});
                }
            },
            diseaseOrAccident: {
                get() {
                    return this.getClaimantDetail('diseaseOrAccident');
                },
                set(value) {
                    this.updateClaimantDetail({key: 'diseaseOrAccident', value})
                        .then(() => {
                            if (this.diseaseOrAccident === 'disease') {
                                this.accidentType = null;
                                this.otherAccidentType = null;
                            } else if (this.diseaseOrAccident === 'accident') {
                                this.diseaseType = null;
                                this.otherDiseaseType = null;

                            }
                        })
                        .then(this.updateValid.bind(this));
                }
            },
            accidentType: {
                get() {
                    return this.getClaimantDetail('accidentType');
                },
                set(value) {
                    this.updateClaimantDetail({key: 'accidentType', value})
                        .then(this.updateValid.bind(this));
                }
            },
            accidentTypeOther: {
                get() {
                    return this.getClaimantDetail('accidentTypeOther');
                },
                set(value) {
                    this.updateClaimantDetail({key: 'accidentTypeOther', value})
                        .then(this.updateValid.bind(this));
                }
            },
            diseaseType: {
                get() {
                    return this.getClaimantDetail('diseaseType');
                },
                set(value) {
                    this.updateClaimantDetail({key: 'diseaseType', value});
                }
            },
            diseaseTypeOther: {
                get() {
                    return this.getClaimantDetail('diseaseTypeOther');
                },
                set(value) {
                    this.updateClaimantDetail({key: 'diseaseTypeOther', value});
                }
            },
            defendantName: {
                get() {
                    return this.getClaimantDetail('defendantName');
                }
            },
            claimNarrative: {
                get() {
                    return this.getClaimantDetail('claimNarrative');
                },
                set(value) {
                    this.updateClaimantDetail({key: 'claimNarrative', value});
                }
            },
            dateOfAssumedSettlement: {
                get() {
                    return this.getClaimantInfoValue('dateOfAssumedSettlement');
                },
                set(value) {
                    this.updateClaimInfoValue({key: 'dateOfAssumedSettlement', value});
                    this.checkIncomePeriods();
                    this.updateLife(this.claimant.lifeExpectancy);
                }
            },
            dateOfAssumedSettlementInPast: {
                get() {
                    let mAssumedSettlement = moment(this.dateOfAssumedSettlement, 'DD/MM/YYYY');

                    if (!mAssumedSettlement.isValid()) {
                        return false;
                    }

                    return mAssumedSettlement.isBefore(moment());
                }
            },
            discountRate: {
                get() {
                    return this.getClaimantInfoValue('discountRate');
                },
                set(value) {
                    this.updateClaimInfoValue({key: 'discountRate', value});
                }
            },
            preLitOrLit: {
                get() {
                    return this.getClaimantInfoValue('proceduralStatus');
                },
                set(value) {
                    this.updateClaimInfoValue({key: 'proceduralStatus', value});
                }
            },
            dateOfServiceProceedings: {
                get() {
                    return this.getClaimantInfoValue('dateOfServiceProceedings');
                },
                set(value) {
                    this.updateClaimInfoValue({key: 'dateOfServiceProceedings', value});
                }
            },
            isValid() {
                return (
                    this.$valid()
                    && this.isValidClaimantSolicitor()
                    && this.isValidDefendant()
                );
            },
        },
        data() {
            return {valid: false}
        },
        mixins: [
            FormValidator
        ],
        mounted() {
            this.fetchSubMenu('lost');
        },
        components: {
            StepButton,
            Control,
            ControlError,
            ControlWarning,
            DateInput,
            WarningBox,
            Typeahead,
            DateInputDOB
        },
        watch: {
            isValid() {
                this.updateValid();
            }
        },
        methods: {
            ...mapActions('lost/claimant', [
                'updateClaimantValue',
                'updateClaimantDetail',
                'updateClaimInfoValue',
                'updateOnsetAndAssumedDod',
                'updateLifeExpectancy',
                'checkIncomePeriods'
            ]),
            ...mapActions('menu', [
                'updateMenu',
                'updateSubMenu'
            ]),
            updateValid() {
                return setStepValid(this.isValid);
            },
            fetchSubMenu(menu) {
                this.updateMenu(true);
                this.updateSubMenu(menu);
            },
            updateLife(lifeExpectancy) {
                if (!validDate(this.dateOfBirth) || !validDate(this.dateOfAssumedSettlement)) {
                    return;
                }
                this.updateLifeExpectancy({lifeExpectancy})
            },
            assumedSettlementDateRules() {
                if (validDate(this.dateOfServiceProceedings)) {
                    return moment(this.dateOfAssumedSettlement, 'DD/MM/YYYY')
                        .isSameOrAfter(moment(this.dateOfServiceProceedings, 'DD/MM/YYYY'));
                }
                return true;
            },
            serviceProceedingsDateRules() {
                return moment(this.dateOfServiceProceedings, 'DD/MM/YYYY')
                    .isSameOrBefore(moment(this.dateOfAssumedSettlement, 'DD/MM/YYYY'));
            },
            isValidClaimantSolicitor() {
                return this.claimantSolicitor
                    && this.claimantSolicitor.name !== null
                    && this.claimantSolicitor.name !== '';
            },
            isValidDefendant() {
                return this.defendantName
                    && this.defendantName.name !== null
                    && this.defendantName.name !== '';
            },
            updateClaimantSolicitors(value) {
                this.updateClaimantDetail({key: 'claimantSolicitor', value});
            },
            updateDefendant(value) {
                this.updateClaimantDetail({key: 'defendantName', value});
            }
        },
    }
</script>



// WEBPACK FOOTER //
// ClaimantDetails.vue?4ba2bcac